import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  current_page: 1,
  page_size: 10,
  has_more: false,
  total_page: 0,
  total_count: 0,
  data: [],
  filters: {
    doctor: [],
  },
};

export const UserMasterSlice = createSlice({
  name: "UserMasterReducer",
  initialState,
  reducers: {
    setUserMasterList: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    setDoctorComboList: (state, action) => {
      state.filters.doctor = action.payload;
    },
  },
});

export const { setUserMasterList, setDoctorComboList } =
  UserMasterSlice.actions;

export default UserMasterSlice.reducer;
